export default "__VITE_ASSET__e7062d5e__"